import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Finance.ClaimJobPayment.Save.IRequest;
type Response = Api.Finance.ClaimJobPayment.Save.IResponse;
type Headers = Api.Finance.ClaimJobPayment.Save.IHeaders;
const url = '/api/Finance/ClaimJobPayment';
export default async function claimJobPaymentSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
